import ReviewsRecommendation from './ReviewsRecommendation'

export default ReviewsRecommendation
